import { Reducer } from 'redux'

import { ActionTypes, TransactionDetails, TRANSACTION_DETAILS_ACTIONS } from './types'

const initialState = {
  isLoading: false,
  transactionId: '',
  transactionDetails: {
    key: '',
    transactionId: '',
    transactionType: '',
    transactionHash: null,
    transactionHashUrl: null,
    walletType: '',
    method: '',
    accountHolderName: '',
    amount: {
      prefix: '',
      postfix: '',
    },
    fee: '',
    tax: '',
    netAmount: {
      prefix: '',
      postfix: '',
    },
    currency: {
      source: '',
      destination: '',
    },
    createdDate: '',
    completedDate: '',
    status: '',
    note: null,
    sourceDestination: null,
    merchantDescription: null,
    network: null,
    bankAccountNo: null,
    bankName: null,
    isDeclarationRequired: false,
  },
}

type State = {
  isLoading: boolean
  transactionId: string
  transactionDetails: TransactionDetails
}

export const transactionDetails: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case TRANSACTION_DETAILS_ACTIONS.SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.isLoading,
      }
    }

    case TRANSACTION_DETAILS_ACTIONS.GET_TRANSACTION_DETAILS: {
      return {
        ...state,
        transactionDetails: action.transactionDetails,
        isLoading: false,
      }
    }

    default:
      return state
  }
}
